"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GanttChart = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Bar_1 = require("../Bar");
var style_ganttchart = {
    position: "relative",
    minHeight: "150px"
};
var style_ganttchart__bar = {
    height: "100%",
    width: "6%",
    borderRadius: "4px",
    background: "rgba(30, 30, 30, 0.1)",
    marginRight: "1%",
    display: "inline-block"
};
var style_ganttchart__line = {};
var daysInSpan = function (sd, ed) {
    return Math.round((ed - sd) / (1000 * 60 * 60 * 24));
};
var calculateWidth = function (psd, ped, sd, ed) {
    var parentLength = daysInSpan(psd, ped);
    var length = daysInSpan(sd, ed);
    return (length / parentLength) * 100;
};
var calculateLeft = function (psd, ped, sd) {
    var parentLength = daysInSpan(psd, ped);
    var daysUntilStart = daysInSpan(psd, sd);
    return (daysUntilStart / parentLength) * 100;
};
var sectionHeight = 34;
var GanttChart = function (props) {
    var height = props.lines.length * sectionHeight;
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "ganttchart", style: __assign(__assign({}, style_ganttchart), { height: height }) }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: style_ganttchart__bar }), (0, jsx_runtime_1.jsx)("div", { className: "ganttchart__bar", style: __assign(__assign({}, style_ganttchart__bar), { marginRight: "0" }) }), props.lines.map(function (ld, idx) {
                var width = calculateWidth(props.startDate, props.endDate, ld.startDate, ld.deadline);
                var left = calculateLeft(props.startDate, props.endDate, ld.startDate);
                var top = idx * sectionHeight + sectionHeight / 2;
                var progressWidth = width * (ld.progress / 100);
                return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "ganttchart__line", style: style_ganttchart__line }, { children: [(0, jsx_runtime_1.jsx)(Bar_1.Bar, { type: Bar_1.BarTypes.PRIMARY, width: progressWidth, height: "10", style: {
                                position: "absolute",
                                top: top,
                                left: "".concat(left, "%"),
                                borderRadius: "4px",
                                width: "".concat(progressWidth, "%"),
                                zIndex: 2
                            } }), (0, jsx_runtime_1.jsx)(Bar_1.Bar, { type: Bar_1.BarTypes.OUTLINE_PRIMARY, width: width, height: "10", style: {
                                position: "absolute",
                                top: top,
                                left: "".concat(left, "%"),
                                borderRadius: "4px",
                                width: "".concat(width, "%"),
                                zIndex: 1
                            } })] })));
            })] })));
};
exports.GanttChart = GanttChart;
